import Settings from '../../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 38,
    TINT: 0xffe88c,
    SHADOW: { OFFSET: 4, TINT: 0x000000, ALPHA: 0.5 },
};

export default class Subtitle extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number, text: string) {
        super(scene, x, y);

        this.setupBG();
        this.setupLabel(text);
    }

    private setupBG(): void {
        const frame = 'gui/popups/shop/bg_subtitle';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.bg);
    }

    private setupLabel(text: string): void {
        this.label = this.scene.add.bitmapText(0, 0, LABEL.FONT, text, LABEL.SIZE);
        this.label.setTint(LABEL.TINT);
        this.label.setOrigin(0.5);
        this.label.setDropShadow(LABEL.SHADOW.OFFSET, LABEL.SHADOW.OFFSET, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add(this.label);
    }
}
